export default "__VITE_ASSET__DhK6wzPi__"